export const reasonForNotSigning = {
  async: false,
  validate: function(data: any, field: any, args: any) {
    const [ignore_field] = args
    data = data.original
    if (
      data.toi &&
      data[ignore_field] &&
      !Number(data.toi_signed) &&
      !data.reason_for_not_signing_id
    ) {
      throw new Error(
        "É necessário informar um motivo para não ter assinado o TOI."
      )
    } else return true
  },
}
